<template>
  <div class="d-inline">
    <i
      class="fa fa-circle-o-notch fa-spin"
      v-if="!filters && !error"
    />
    <i
      class="fa fa-exclamation-triangle"
      title="Problema de conexão"
      v-else-if="error"
    />
    <div
      v-else
      class="text-left"
    >
      <span
        v-for="(item, index) in segment.context"
        :key="index"
      >
        <span
          v-if="item.query"
          v-html="getFilterString(item)"
        />
      </span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    segment: null,
    filters: null,
  },

  data () {
    return {
      error: false,
    };
  },

  methods: {
    getFilterString (item) {
      const filter = this.filters.filter((element) => `${element.filter}` === `${item.filter}`)[0];

      const description = filter?.description;
      const operator = filter?.operators[item.operator] || '';

      // query can be a query string (eg. name == John), a key to a value in a array (eg. mail id), a value of an object in a array (eg. tag name), or a comma separated list (eg. multiselect of tag names)
      let query = filter?.options[`${item.query}`] || item.query;

      if (typeof (filter?.options[0]) == 'object') {
        query = filter?.options?.filter((element) => `${element.id}` === `${item.query}`)[0]?.name || filter?.options?.filter((element) => `${element.name}` === `${item.query}`)[0]?.name || item.query;
      }

      if (! operator && ! query) {
        if (! description) {
          return null;
        }
        return `É <b>${description}</b><br>`;
      }

      if (operator) {
        return `<b>${description}</b>: ${operator} <b>${query}</b><br>`;
      }

      return `<b>${description}</b>: ${query}<br>`;
    },

  },
};
</script>
